import { Table,Button, Col, Flex, Image, Row, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./TicketManagement.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GetCardLayout } from "../../../../common/getCardLayout";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../constants/routeConsts";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { getTicketManagementByIdAction } from "../../../../../redux/services/ticket-management/ticketManagementServices";
import { colors } from "../../../../../constants/colors";
import { dateObjToDispViewDate,timeObjToDispViewTimeWithSuffix } from "../../../../../utils/utils";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useTranslation } from "react-i18next";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const TicketManagementDetails = () => {

  const {t} = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { selectedTicketManagementId } = useSelector((state) => state.tickets);

  const [ticketManagementDetails, setTicketManagementDetails] = useState(null);

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedTicketManagementId &&
      selectedTicketManagementId !== "" &&
      selectedTicketManagementId !== null &&
      selectedTicketManagementId !== undefined
    ) {
      const dataToBeSent = {
        selectedTicketManagementId,
      };
      dispatch(getTicketManagementByIdAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          const response = apiRes;
          setTicketManagementDetails(response);
        }
      );
    }
  }, []);

  const getColorBasedOnStatus = (status) => {
    switch (status) {
      case "Pending":
        return { background: colors.lightPeach, color: colors.salmon };

      case "Open":
        return {
          background: colors.powderBlue,
          color: colors.oceanBlue,
        };
        
        case "Closed":
          return {
            background: colors.lightPinkishRed,
            color: colors.darkMaroon,
          };

      default:
        break;
    }
  };

  return (
    <div className={styles.ticketManagementDetailsContainer}>
      <GetCardLayout>
        <Flex vertical gap="2rem">
          <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() =>
                navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT))
              }
            />
            <Typography.Title underline level={2}>
              {t("CommonUtils.ticketManagementInfo")}
            </Typography.Title>
          </Flex>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <RequiredLabel text="Ticket Number" required={false} />
              <div>{ticketManagementDetails?.ticket_number ?? ""}</div>
            </Col>
            <Col span={8}>         
              <RequiredLabel text={t("CommonUtils.fullName")} required={false} />
              <div>{ticketManagementDetails?.name ?? ""}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.email")} required={false} />
              <div>{ticketManagementDetails?.email ?? ""}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.phoneNumber")} required={false} />
              <div>{ticketManagementDetails?.phone ?? ""}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("dateofRequest")} required={false} />
              <div>
              <p>{`${dateObjToDispViewDate(ticketManagementDetails?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(ticketManagementDetails?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
              </div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.subject")} required={false} />
              <div>{ticketManagementDetails?.subject ?? ""}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("Modules.AutoCredit.status")} required={false} />
              <Tag
                bordered={false}
                style={getColorBasedOnStatus(ticketManagementDetails?.status)}
              >
                {ticketManagementDetails?.status ?? ""}
              </Tag>
            </Col>
            <Col span={16}>
              <RequiredLabel text={t("CommonUtils.message")} required={false} />
              <div>{ticketManagementDetails?.message ?? ""}</div>
            </Col>
          </Row>
        </Flex>
      </GetCardLayout>
    </div>
  );
};

export default TicketManagementDetails;
